"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var validators_1 = __importDefault(require("../../validators"));
function validate() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var validatorName = args[0],
    valueToTest = args[1],
    properties = args[2];
  var validatorToUse = validators_1.default[validatorName];
  if (!validatorToUse) {
    throw new Error("Validator of type ".concat(validatorName, " does not exist, check validator name or lib version"));
  } else if (typeof validatorName !== 'string') {
    throw new TypeError('Invalid datatype to validator name, expected string');
  }
  return Object.assign(Object.assign({}, validatorToUse.run(valueToTest, properties)), {
    validator: validatorName
  });
}
exports.default = validate;